// extracted by mini-css-extract-plugin
export default {"comparisonTable":"Compare_comparisonTable__DH1wO"};